<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Scholarships'
}
</script>

<style scoped>
</style>
